"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMember = void 0;
/**
 * Represents a defined collection of entities that may be discussed or acted upon collectively but which are not expected to act collectively, and are not formally or legally recognized; i.e. a collection of entities that isn't an Organization.
 */
var GroupMember = /** @class */ (function () {
    function GroupMember() {
    }
    return GroupMember;
}());
exports.GroupMember = GroupMember;
